// src/components/Layout.jsx
import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../../my-app/src/Components/Navbar/Navbar";
import Footer from "../src/Components/Footer/Footer";
import connect from "../src/Components/connect/connect"

const Layout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Navbar at the top */}
      <Navbar />

      {/* Main content (pages will render here) */}
      <main className="flex-grow">
        <Outlet />
      </main>
<connect />
      {/* Footer at the bottom */}
      <Footer />
    </div>
  );
};

export default Layout;
